import { useUserStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useUserStore";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useInsiderTermsAndConditionsAcceptanceGate: IGateHook = () => {
  const modalType = useModalType();
  const { userCanPlaceOrder } = useUserStore();

  if (
    userCanPlaceOrder &&
    modalType === PromoModalType.INSIDER_TERMS_AND_CONDITIONS_ACCEPTANCE
  ) {
    return PromoModalType.INSIDER_TERMS_AND_CONDITIONS_ACCEPTANCE;
  }

  return undefined;
};
